import { createAction } from "redux-actions";

import { moduleSlug } from "../../constants";

export const requestNormalizersByUrls = createAction(`${moduleSlug}/REQUEST_NORMALIZERS_BY_URLS`);
export const setNormalizersByUrls = createAction(`${moduleSlug}/SET_NORMALIZERS_BY_URLS`);

export const updateConfigDataStepThree = createAction(`${moduleSlug}/UPDATE_CONFIG_DATA_STEP_THREE`);
